import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { useState, useRef, useEffect, ChangeEvent, KeyboardEvent } from "react";
import { SearchIcon } from "../../../../../assets/icons/MUI/LayoutIcons";
import { useTranslation } from "react-i18next";
import RecentSearchList from "./RecentSearchList";
import { useNavigate } from "react-router-dom";
import SearchList from "./SearchList";
import { getSearchValueRoute } from "../../../../../routers/routeUtils";

const SearchBar = () => {
  const [isFocused, setIsFocused] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const containerRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClickOutside = (event: MouseEvent) => {
    if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
      setIsFocused(false);
    }
  };

  useEffect(() => {
    if (isFocused) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFocused]);

  const handleChangeText = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setSearchValue(e.target.value);
  };

  const handleNavigateToSearch = () => {
    if (searchValue.length > 0) navigate(getSearchValueRoute(searchValue));
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") handleNavigateToSearch();
  };

  return (
    <Box ref={containerRef} sx={{ position: "relative" }}>
      <TextField
        value={searchValue}
        onChange={handleChangeText}
        onFocus={() => setIsFocused(true)}
        placeholder={t("layout.nav.search")}
        onKeyDown={handleKeyDown}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton disableRipple sx={{ padding: "0" }} onClick={handleNavigateToSearch}>
                <SearchIcon style={{ fill: "none", width: "24px", height: "24px" }} />
              </IconButton>
            </InputAdornment>
          ),
          autoComplete: "new-password",
        }}
        variant="outlined"
        sx={{
          width: { xs: "100%", md: "400px" },
          maxWidth: "100%",
          "& .MuiOutlinedInput-root": {
            padding: "0 20px",
          },
        }}
      />
      {isFocused && (
        <Box
          sx={{
            position: "absolute",
            top: "calc(100% + 3px)",
            left: 0,
            border: "1px solid #EAECF0",
            background: "white",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            padding: "20px 16px",
            width: "400px",
            zIndex: 999,
          }}
        >
          {!searchValue && <RecentSearchList setIsFocused={setIsFocused} clearSearch={() => setSearchValue("")} />}
          {searchValue && (
            <SearchList searchValue={searchValue} setIsFocused={setIsFocused} clearSearch={() => setSearchValue("")} />
          )}
        </Box>
      )}
    </Box>
  );
};

export default SearchBar;
